import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Business from "./Business";
import Testimonial from "./Testimonial";

export default function Healthcare() {
   

    
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Healthcare</h1>
                </div>
            </div>

         
            <Container className="it-overview mt-5 mb-5" >
                {/* <h6>OVERVIEW</h6> */}
                <h3 className="text-center" style={{ color: '#0e2b5c', paddingBottom: '15px' }}>Transforming Patient Care with Digital Excellence</h3>
                <div className="overview-container" style={{ padding: '0 12%', color: '#627792', fontSize: '18px', fontWeight: '500', lineHeight: '1.8' }}>
                    <p >The healthcare industry is evolving rapidly, and technology is the key to better patient outcomes. We deliver innovative solutions that enhance hospital management, streamline patient care, and improve efficiency. From telemedicine to AI-powered diagnostics, we ensure healthcare providers can offer precise and timely treatments. Our solutions bridge the gap between medical professionals and patients, ensuring seamless care delivery.
                    </p>
                </div>
            </Container>

            {/**benefit */}

            <section className="py-5 text-light mb-5" style={{ backgroundColor: "#141b29" }}>
                {/* <h6 className="text-uppercase text-center text-info mb-2">Benefits to Healthcare on</h6> */}
                <h2 className="text-center mb-5">Our Solutions for Healthcare
                </h2>
                <Container>
                    <Row>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>AI-Driven Diagnostics & Telemedicine for Remote Healthcare Access</h5>
                                <p>AI-powered medical imaging and predictive analytics enable faster and more accurate disease diagnosis. Telemedicine platforms facilitate remote consultations, bridging the gap between patients and healthcare providers, especially in underserved areas. This technology reduces wait times, enhances accessibility, and improves patient outcomes.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Integrated Electronic Health Records (EHR) for Seamless Patient Data Management</h5>
                                <p>A centralized digital health record system ensures easy access to patient data across healthcare facilities. This enhances coordination among specialists, minimizes paperwork, and reduces errors caused by fragmented data. AI integration further optimizes EHR by analyzing patient history to recommend more effective treatment strategies.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Automated Scheduling & Resource Optimization for Enhanced Operational Efficiency</h5>
                                <p>Intelligent scheduling algorithms help hospitals and clinics optimize appointment bookings, reducing wait times and maximizing staff productivity. Automated systems ensure efficient allocation of resources such as hospital beds, equipment, and medical personnel. This leads to smoother operations, cost savings, and improved patient experiences.</p>
                            </div>
                        </Col>
                        <Col sm={12} lg={3} md={12} className="mb-3">
                            <div className="list-item">
                                <h5>Personalized Treatment Plans with AI for Tailored Healthcare Solutions</h5>
                                <p>Advanced AI models analyze patient data, including genetic information, lifestyle habits, and medical history, to create highly customized treatment plans. This approach enhances efficacy by recommending medications, therapies, and lifestyle changes tailored to individual patients. AI continuously evolves with new data, ensuring treatments adapt to patient needs.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>

            <Business />
        </>
    )
}